import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import { withFormik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { withI18n } from 'react-i18next';
import { Auth } from 'aws-amplify';

const ForgotPasswordForm = props => {
  const { t, errors, touched, isSubmitting } = props;
  return (
    <Form>
      {errors.main && <Alert color="danger">{errors.main}</Alert>}
      <div>
        <label className="font-weight-bold" htmlFor="inputEmail">
          {t('email')}
        </label>
        <Field
          type="email"
          name="email"
          placeholder={t('email')}
          className="form-control mb-3"
        />
        {touched.email && errors.email && (
          <div className="invalid-feedback d-block">{t(errors.email)}</div>
        )}
      </div>
      <button
        className="btn btn-primary btn-block mt-5 mb-5"
        type="submit"
        disabled={isSubmitting}
      >
        {t('set_new_password')}
      </button>
    </Form>
  );
};

const FormikForgotPasswordForm = withFormik({
  mapPropsToValues({ email }) {
    return {
      email: email || '',
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('email_not_valid')
      .required('email_required'),
  }),
  handleSubmit(values, { setErrors, setSubmitting, props }) {
    const { email } = values;
    const adjustedEmail = email.trim().toLowerCase();
    Auth.forgotPassword(adjustedEmail)
      .then(() => {
        props.next(adjustedEmail);
      })
      .catch(err => {
        console.error(err);
        setErrors({ main: err.message });
      });
    setSubmitting(false);
  },
})(ForgotPasswordForm);

ForgotPasswordForm.propTypes = {
  t: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default withI18n()(FormikForgotPasswordForm);
